import {Sorting} from './sorting';

export class PageState {
  pageNumber: number;
  rowsOnPage: number;
  editRow: any;
  sorting: Sorting[] = [];
}
